import { apiClient } from './authService';

/* =======================
   Types
======================= */

export interface Account {
  id: number;
  code: string;
  name: string;
  type: string;
  description?: string | null;
}

/* =======================
   API Calls
======================= */

export async function listAccounts() {
  const res = await apiClient.get('/accounts');
  return res.data as Account[];
}
